export class Color {
    themeColor = [0, 0, 0];
  
    constructor(hue = 0, saturation = 0, lightness = 0) {
      this.hue = hue;
      this.saturation = saturation;
      this.lightness = lightness;
    }
  
    setColor(color = '') {
      const [hue = 0, saturation = 0, lightness = 0] = (color || '')
        .replace(/[\s\%]/g, '')
        .split(',')
        .map(Number);
      this.themeColor = [hue, saturation, lightness];
      this.hue = hue;
      this.saturation = saturation;
      this.lightness = lightness;
      return this;
    }
  
    toHSLString() {
      const { hue, saturation, lightness } = this;
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }
  
    lighten(percentage) {
      let { hue, saturation, lightness } = this;
  
      if (lightness === 0 && percentage >= 0) {
        return this.darken(percentage * -1);
      }
  
      const offset = percentage < 0 ? lightness : 100 - lightness;
      lightness = lightness + offset * (percentage / 100);
  
      return new Color(hue, saturation, lightness);
    }
  
    darken(percentage) {
      let { hue, saturation, lightness } = this;
      if (saturation === 0 && percentage >= 0) {
        return this.lighten(percentage * -1);
      }
  
      const soffset = percentage < 0 ? 100 - saturation : saturation;
      const loffset = percentage < 0 ? 100 - lightness : lightness;
      saturation = saturation - soffset * (percentage / 100);
      lightness = lightness - loffset * (percentage / 90);
  
      return new Color(hue, saturation, lightness);
    }
}

export const generatePalette = (themeColor) => {
    const color = new Color().setColor(themeColor);
    return {
      50: color.lighten(90).toHSLString(),
      100: color.lighten(80).toHSLString(),
      200: color.lighten(60).toHSLString(),
      300: color.lighten(40).toHSLString(),
      400: color.lighten(20).toHSLString(),
      500: color.toHSLString(),
      600: color.darken(20).toHSLString(),
      700: color.darken(40).toHSLString(),
      800: color.darken(60).toHSLString(),
      900: color.darken(80).toHSLString(),
    }
}